var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0"},[_vm._v("\n  "+_vm._s(_vm.title)+": "),(_vm.value)?_c('b',[_vm._v(_vm._s(_vm.value))]):_c('v-icon',{attrs:{"color":"red","size":"16"}},[_vm._v("\n    error\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }